import './SideNavigation.scss';
import { NavLink, useLocation } from 'react-router-dom';
import { sidemenuItems, sidemenuItemsNoUser } from '@features/Layout/utils/constants';
import { useSearchSidebarContext } from '@project/contexts/SearchSidebarContext';
import { useGetUserContextQuery } from '@project/store/services/userContextApi';

function SideNavigation() {
  const location = useLocation();

  const { showSearchBar, setShowSearchBar } = useSearchSidebarContext();
  const { data: userData } = useGetUserContextQuery('');

  const onToggle = (e: any) => {
    e.preventDefault();
    setShowSearchBar(!showSearchBar);
  }

  const getMenu = (): JSX.Element[] => {
    const currPath = location.pathname.split('/');
    return (userData ? sidemenuItems: sidemenuItemsNoUser).map((item: any, key: number) => {
      return (
        <li key={key}>
          <NavLink
            to={item.urlPath || location.pathname}
            className={({ isActive }) =>
              `${isActive && item.urlPath && item.urlPath.includes(currPath[1]) ? 'sidemenu-selected' : 'sidemenu-unselected'}`
            }
            // end
          >
            <div className="nav-item-wrapper">
              {item.isHexIcon ? (
                <div className="nav-hex-wrapper">
                  <i className="fa-thin fa-hexagon"></i>
                  <span>{item.iconText}</span>
                </div>
              ) : (
                <div className="nav-hex-wrapper">
                  <i className={item.iconName}></i>
                </div>
              )}

              <span>{item.displayName}</span>
            </div>
          </NavLink>
        </li>
      );
    });
  };

  return (
    <>
      <aside className={`nav-container`}>
        <section className='toggle-filter'>
          <a href="#" onClick={onToggle}>
            <i className="fa-solid fa-bars"></i>
          </a>
        </section>
        <section className="dvr-subsite-row flex flex-row">
          <div className={`hexagon-wrapper`}>
            <i className="icon icon-hexagon hex-1" />
            <i className="icon icon-hexagon hex-2" />
            <i className="icon icon-hexagon hex-3" />
            <div className="inner-text">DIGITAL RESOURCES</div>
          </div>
        </section>

        <div className="row-divider" />

        <section className="nav-menu-row">
          <ul>{getMenu()}</ul>
        </section>
      </aside>
    </>
  );
}

export default SideNavigation;
